import { createSelector } from 'reselect'
import getPaymentScheduleAdjustmentRequestInfo from './getPaymentScheduleAdjustmentRequestInfo'
import { getPaymentScheduleKey } from 'lib/payment/paymentScheduleUtils'

const getCurrentAdjustedPaymentSchedule = createSelector(
  (state: App.State) => state.paymentSchedule,
  getPaymentScheduleAdjustmentRequestInfo,
  (paymentSchedule, adjustedPaymentScheduleRequestInfo): App.AdjustedPaymentScheduleChargeData | undefined => {
    const key = getPaymentScheduleKey(adjustedPaymentScheduleRequestInfo)

    // Check if the key exists in adjustedCharges before accessing it
    if (key && paymentSchedule.adjustedCharges && key in paymentSchedule.adjustedCharges) {
      return paymentSchedule.adjustedCharges[key]
    }

    return undefined
  },
)

export default getCurrentAdjustedPaymentSchedule
